import { Button } from "../../IO";
import { Scale, CreateElement, AddMouseDownUpListener, SetStyles } from "../../MyHelpers";
import { ButtonColors, ButtonState, Panel } from "./panel";
import { SpeedIconMap, VolumeIconsMap } from "./IPopUpPanelIcons";
import gsap from "gsap";
import { AudioManager } from "../../AudioManager";
import { CelebrationType, SpeedType } from "../../api";;
import { ZIndex } from "../../ZIndex";
import { service } from "../../services";
import { Translator } from "../../Translator";
import { ISystemContext } from "../../Context/SystemContext";
import { SpeedChangedCallback, SpeedManager, speedTypeMap} from "../../SpeedManager";

export interface PopUpSettingsParams
{
    panelColors: ButtonColors, 
    translator: Translator, 
    audio: AudioManager,
    // backendSettings: IBackendSettingsService,
    // panel: Panel, 
    systemContext: ISystemContext,
    speedManager: SpeedManager,

}

export class PopUpSettings { 
    protected buttonState: Map<Button, ButtonState> = new Map<Button, ButtonState>();


    protected SELECTOR = `input[type="range"]::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: ${Scale.Wpx(80)};
        height: ${Scale.Hpx(120)};
        background-image: linear-gradient(to bottom, #b0b0b0 0%, #ffffff 50%, #a8a8a8 100%);
        cursor: pointer;
        border-radius: ${Scale.XYpx(16)};
        border: ${Scale.XYpx(7)} solid transparent;
        border-style: "inset";
        margin: ${Scale.Wpx(5)} ${Scale.Hpx(10)};
        display: "flex";
        background-origin: "border-box";
        background-clip: "content-box; border-box";
        border: solid;
        border-color: darkgoldenrod;


    }`;

    protected popUpMenu: HTMLElement;
    protected volumeSelectorStyle: HTMLElement;
    protected SpeedSelectortStyle: HTMLElement;
    
    protected volumeRange: HTMLInputElement;
    protected SpeedRange: HTMLInputElement;
    protected butSpeed: HTMLDivElement

    protected allowToHidePopUpItems: boolean = true;
    protected view:HTMLElement;

    protected btnColors: ButtonColors;
    protected butVolume: HTMLDivElement;

    protected translator: Translator;
    protected audio: AudioManager;

    protected butDenom:HTMLElement;
    protected denomElem:HTMLElement;
    protected butHelp:HTMLElement;
    protected attendantElem:HTMLElement;


    // protected backendSettings: IBackendSettingsService;
    protected systemContext:ISystemContext;
    protected butElem: Map<Button, HTMLElement> = new Map<Button, HTMLElement>();
    protected speedManager: SpeedManager;

    

    public constructor(parameters: PopUpSettingsParams)
    {
        this.btnColors = parameters.panelColors;
        this.translator = parameters.translator
        this.audio = parameters.audio;
        // this.backendSettings = parameters.backendSettings;
        this.speedManager = parameters.speedManager;

        this.systemContext = parameters.systemContext;
        
        this.ConstructHtml();

    }
    

    public ConstructHtml() {

       this.view = CreateElement("div", {
        classes:["pop-up", "container"],
        style:
        {
            display: "none",
            flexDirection: "column",
            position: "absolute",
            bottom: Scale.Ypx(0),
            width: Scale.Wpx(1920),
            height: Scale.Hpx(1080),
            justifyContent: "center",
            alignItems: "center",
            zIndex: ZIndex.SettingsMenu.toString(),
            background: "rgba(0,0,0,0.8)",
        },
        
       })
       this.view.addEventListener('mousedown', () => {if (this.allowToHidePopUpItems) this.HidePopUp()});

        let cssLinear: Partial<CSSStyleDeclaration> = {
            borderWidth: Scale.XYpx(5),
            borderStyle: "solid",
            position: "relative",
            margin: "0px auto",
            bottom: Scale.Ypx(5),
            filter: `blur(${Scale.XYpx(2)})`,
            width: "80%",
            borderImage: this.btnColors.linearColor

        };


        let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "column",
            //justifyContent: "flex-end",
        };

        let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
            display: "flex",
            flexDirection: "row",
            flexGrow: "1",
            alignItems: "end",
        };

        let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
            flexGrow: "1",
            height: Scale.Hpx(47),
            width: Scale.Wpx(85),
        };

        let cssButton: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),

            border: `${Scale.XYpx(7)} solid transparent`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",

            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(100),

            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",

            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",
            backgroundImage: this.btnColors.backgroundButtonColor
        };

        let cssLabel: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(20),
            lineHeight: "0px",
            //color: "white",
            textAlign: "center",


            fontFamily: "NotoSansDisplay-Bold",
            fontWeight: "bold",

            color: "white",
            textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        };

        let SvgIcon: Partial<CSSStyleDeclaration> =
        {
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center"
        }

        let horizontalMiniMenu: Partial<CSSStyleDeclaration> =
        {
            display: "flex",
            flexDirection: "row",
            //width:"100%",
            //height:"100%",
            alignItems: "center",
            justifyContent: "center"
        }

        let cssMessageValue: Partial<CSSStyleDeclaration> = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: Scale.fhpx(20),

            color: "white",
            textShadow: "0 0 10px black",
            background: "transparent",
            position: "relative",
            top: "0px",

        };

        let cssCredit: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(35),
            lineHeight: Scale.Hpx(40),
            textAlign: "center",
            height: "100%",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            color: "white",

            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(6),
        };

        let cssCurrency: Partial<CSSStyleDeclaration> = {
            fontSize: Scale.fhpx(25),
            textAlign: "center",
            color: "yellow",
            textShadow: `0 0 ${Scale.XYpx(10)} black`,
            position: "relative",
            top: Scale.Ypx(12),
            left: Scale.Ypx(0),
            margin: Scale.Ypx(0),
        };

        this.popUpMenu = CreateElement("div", {
            classes: ["popup-menu", "items"],
            parentToAppend: this.view,
            // childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
            style: {
                //position: "absolute",
                //display: "none",
                // bottom: Scale.Ypx(165),
                backgroundImage: this.btnColors.backgroundButtonColor,
                justifyContent: "center",
                width: Scale.Wpx(900),
                height: Scale.Hpx(1050),
                borderRadius: Scale.XYpx(16),

                border: `${Scale.XYpx(7)} solid transparent`,
                //backgroundClip: "padding-box",
                borderStyle: "inset",
    
                margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                // height: Scale.Hpx(216),
    
                backgroundOrigin: "border-box",
                backgroundClip: "content-box, border-box",   
                flexDirection: "column",
                //left: Scale.Xpx(15),
                //zIndex: ZIndex.SettingsMenu.toString()
            }
        })
        this.popUpMenu.addEventListener('mouseenter', () => this.allowToHidePopUpItems = false);
        this.popUpMenu.addEventListener('mouseleave', () => this.allowToHidePopUpItems = true);

        let settingTitle= CreateElement("div", {
            classes: ["game-config", "pop-up"],
            parentToAppend: this.popUpMenu,
            style: {
                position: "relative",
                fontSize: Scale.fhpx(64.5),
                textAlign: "center",
                fontWeight: "bold", 
                
                color: "white",
                textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
                lineHeight: Scale.Hpx(133),
            },
            childToAppend: service.translator.Anchor(() => service.translator.t.settingsTitle)
        });

        /* #region Left column */
        let leftCol = CreateElement("div", {
            classes: ["but-vertical-group", "but-group-value-collect"],
            parentToAppend: this.popUpMenu,
            style: {
                ...cssVerticalGroup,
                alignItems: "center",
               // margin:`${Scale.Wpx(15)} ${Scale.Wpx(15)}`,
                justifyContent:"space-around"
            }
        });

        let volumeMenu = CreateElement("div", {
            classes: ["volume-submenu"],
            parentToAppend: leftCol,
            style: {
                ...horizontalMiniMenu,
                justifyContent: "flex-end"

               // rowGap: Scale.Wpx(15),
            }
        })

        this.butVolume = CreateElement("div", {
            classes: ["but-vol", "button"],
            parentToAppend: volumeMenu,
            style: {
                // ...cssButton,
                // ...cssLeftRightButton,
                width: Scale.Wpx(200),
                height: Scale.Hpx(200),
            }
        });

        // this.butVolIcon = CreateElement("div", {
        //     classes: ["but-vol-icon", "icon"],
        //     //innerHTML: PopUpPanelIcons.Volume3,
        //     parentToAppend: this.butVolume,
        //     style: {
        //         // ...cssLabel
        //         ...SvgIcon,
        //     }
        // });

        this.volumeRange = CreateElement("input", {
            parentToAppend:volumeMenu,   
            style: {
                appearance: "none",
                width: Scale.Wpx(600),
                height: Scale.Hpx(50),
                border: "solid darkgoldenrod",
                backgroundColor: "transparent",
                zIndex: "2"
            }         
        });

        this.volumeRange.type = "range";
        this.volumeRange.min = "0";
        this.volumeRange.max = AudioManager.MaxVolumeLevel.toString();


        this.volumeRange.addEventListener("input", ()=>{
            this.audio.SetVolume(this.volumeRange.valueAsNumber);
            this.UpdateIconVolume(this.audio.GetVolumeLevel());
        });

        this.volumeSelectorStyle = CreateElement("style",
        {
            innerHTML:  this.SELECTOR,
            parentToAppend: this.volumeRange

        })

        let volumeBackground = CreateElement("div", {
            classes:["volume-scale", "indicator"],
            parentToAppend: volumeMenu,
            style:{
                width: Scale.Wpx(600),
                height: Scale.Hpx(50),
                position: "absolute",
                //zIndex: "-1",
                display: "flex",
                flexDirection: "column"
                // backgroundColor: "transparente"
            }
        })

        let transparentRectangle = CreateElement("div", {
            parentToPrepend: volumeBackground,
            style:
            {
                width:"100%",
                height: "100%",
                clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                position: "absolute",
                top: "0",
                left: "0",
                // backgroundColor: "orange"
            }
        })

        let gradientRectangle = CreateElement("div", {
            parentToAppend: volumeBackground,
            style:
            {
                width:"100%",
                height: "100%",
                clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                position: "absolute",
                top: "0",
                right: "0",
                backgroundImage: "linear-gradient(-90deg, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                transform: "rotate(180deg)"

            }
        })

        let volumeTitle = CreateElement("div", {
            classes:["volume","title"],
            parentToAppend: leftCol,
            childToAppend: this.translator.Anchor(() => this.translator.t.volumeControlHeader),
            style: {
                ...cssLabel,
                display:"flex",
                // position: "absolute",
                width: "100%",
                height: Scale.Hpx(90),
                // alignItems: "center",
                justifyContent: "center",
            }
        });
        




        let speedMenu = CreateElement("div", {
            classes: ["speed-submenu"],
            parentToAppend: leftCol,
            style:{
                ...horizontalMiniMenu,
                // rowGap: Scale.Wpx(15),
            }
        })
        this.butSpeed = CreateElement("div", {
            classes: ["but-speed", "button"],
            parentToAppend: speedMenu,
            style: {
                // ...cssButton,
                // ...cssLeftRightButton,
                width: Scale.Wpx(200),
                height: Scale.Hpx(200),
            }
        });

        // this.SpeedIcon = CreateElement("div", {
        //     classes: ["but-speed-icon", "icon"],
        //     innerHTML: PopUpPanelIcons.Speed0,
        //     parentToAppend: butSpeed,
        //     style: {
        //         // ...cssLabel
        //         ...SvgIcon
        //     }
        // });
        
        this.SpeedRange = CreateElement("input", {
            parentToAppend:speedMenu,      
            style:
            {
                appearance: "none",
                width: Scale.Wpx(600),
                height: Scale.Hpx(50),
                backgroundImage: "linear-gradient(to right, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                border: "solid darkgoldenrod",
            }      
        });

        this.SpeedRange.type = "range";
        this.SpeedRange.min = "1";
        this.SpeedRange.max = "3";

        this.SpeedRange.addEventListener("input", () =>
        {
            this.SetGameSpeed(this.SpeedRange.valueAsNumber)
        });

        this.SpeedSelectortStyle = CreateElement("style",
        {
            innerHTML:  this.SELECTOR,
            parentToAppend: this.SpeedRange

        })
         let speedTitle = CreateElement("div", {
            classes: ["speed","title"],
            parentToAppend: leftCol,
            childToAppend: this.translator.Anchor(() => this.translator.t.speedControlHeader),

            style:{
                ...cssLabel,
                // position: "absolute",
                width: "100%",
                height: Scale.Hpx(90),
                display: "flex",
                // alignItems: "end",
                justifyContent: "center",

            }
         })


        let miniMenu = CreateElement("div", {
            parentToAppend: leftCol,
            style: {
                ...horizontalMiniMenu,
                // rowGap: Scale.Wpx(15)

            }
        })

        this.butDenom = CreateElement("div", {
            classes: ["but-denom", "button"],
            parentToAppend: miniMenu,
            style: {
                ...cssButton,
                width: Scale.Wpx(120*2),
                height: Scale.Hpx(100*2),
            }
        });

        this.denomElem = CreateElement("div", {
            classes: ["denom-value", "message-value"],
            parentToAppend: this.butDenom,
            style: {
                ...cssLabel,
                lineHeight: "initial",
                fontSize: Scale.fhpx(37.5),
            }
        });

        // let butDenomDenom = CreateElement("div", {
        //     classes: ["denom-denom"],
        //     parentToAppend: this.denomElem
        // });

        /* #region Left column */
        // let leftCol2 = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-group-payout-attendant"],
        //     parentToAppend: this.popUpMenu,
        //     style: {
        //         ...cssVerticalGroup
        //     }
        // });

        this.butHelp = CreateElement("div", {
            classes: ["but-help", "button"],
            parentToAppend: miniMenu,
            style: {
                ...cssButton,
                width: Scale.Wpx(120*2),
                height: Scale.Hpx(100*2),

            }
        });

        let butHelpBack = CreateElement("div", {
            classes: ["help-background"],
            parentToAppend: this.butHelp
        });

        let butHelpLabel = CreateElement("div", {
            classes: ["but-help-icon", "label"],
            parentToAppend: butHelpBack,
            innerHTML: "INFO",
            style: {
                ...cssLabel,
                fontSize: Scale.Wpx(75)
            }
        });

        // this.attendantElem = CreateElement("div", {
        //     classes: ["but-attendant", "button"],
        //     // parentToAppend: miniMenu,
        //     style: {
        //         ...cssButton,
        //         width: Scale.Wpx(120*2),
        //         height: Scale.Hpx(100*2),
        //     }
        // });


        // let btnAttendantLabel = CreateElement("div", {
        //     classes: ["but-attendant-label", "label"],
        //     parentToAppend: this.attendantElem,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.callAttendant),
        //     style: {
        //         ...cssLabel,
        //         lineHeight: "initial",//Scale.fhpx(30),
        //         fontSize: Scale.fhpx(37.5),
        //     }
        // });

        let ExitBtn = CreateElement("div", {
            classes:["but-exit-popup"],
            parentToAppend: leftCol,
            style: {
                ...cssButton,
                width: Scale.Wpx(500),
                height: Scale.Hpx(100),
                backgroundColor: "red",
                backgroundImage: "linear-gradient(#FF0101)",
            },
            mousedown: () => {
                this.HidePopUp();
            },
        });

        let ExitBtnLabel = CreateElement("div",
            {
                classes:["eixt","label"],
                parentToAppend: ExitBtn,
                childToAppend: this.translator.Anchor(() => this.translator.t.backtogametxt),
                style: {
                    ...cssLabel,
                    fontSize: Scale.fhpx(30),
                    // color: "red",
                }
            }
        )


        // // LEFT GROUP
        // let grpLeft = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
        //         ...cssVerticalGroup,
        //         width: "33%",

        //     }
        // });

        // let btnLines = CreateElement("div", {
        //     classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
        //         //height: Scale.Hpx(35),
        //         //position: "relative",
        //         //left: "-224px",
        //         //background: "transparent",
        //         //...cssButton
        //         display: "flex",
        //         //alignItems: "center",
        //         justifyContent: "center",
        //         width: "100%"
        //     }
        // });

        // this.linesMessage = this.translator.Translate(() => this.translator.t.playingOnLines(this.lines));
        // let btnLinesValue = CreateElement("div", {
        //     classes: ["but-lines-value", "message-value"],
        //     parentToAppend: btnLines,
        //     childToAppend: this.linesMessage.location,
        //     style: {
        //         //...cssMessageValue
        //         //display: "flex",
        //         // justifyContent: "center",
        //         // alignItems: "center",
        //         fontSize: Scale.fhpx(20),

        //         color: "white",
        //         textShadow: "0 0 10px black",
        //         background: "transparent",
        //         //position: "absolute",
        //         // top: "8px",
        //         // left: Scale.Hpx(360),
        //     }
        // });

        // let grpDenomBalance = CreateElement("div", {
        //     classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
        //         ...cssHorizontalGroup,
        //         //flexGrow: "1"
        //         justifyContent: "space-evenly",
        //         alignItems: "flex-end",
        //         height: "100%",
        //     }
        // });

        // // grpDenomBalance.addEventListener("mouseenter", () => this.HidePopUp());

        // this.butcash = CreateElement("div", {
        //     classes: ["but-cash", "button"],
        //     parentToAppend: grpDenomBalance,
        //     style: {
        //         ...cssButton,
        //         width: Scale.Wpx(120)//Scale.Wpx(100),
        //         // height: Scale.Hpx(70),
        //         //position: "absolute",
        //     }
        // });

        // let btnCashLabel = CreateElement("div", {
        //     classes: ["but-cash-label", "label"],
        //     parentToAppend: this.butcash,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.collect),
        //     style: {
        //         ...cssLabel
        //     }
        // });

        // let popUpBtn = CreateElement("div", {
        //     classes: ["pop-up","trigger"],
        //     parentToAppend: grpDenomBalance,
        //     style:{
        //         ...cssButton,
        //         width: Scale.Wpx(120),
        //     }

        //     // mousedown: () => {
        //     //     this.ShowPopUp();
        //     // }
        // })

        // let settingsIconDiv = CreateElement("div", {
        //     parentToAppend: popUpBtn,
        //     innerHTML: PopUpPanelIcons.Settings,
        //     style: {
        //         ...SvgIcon

        //     }
        // })

        // let popUpMenuBtnlabel = CreateElement("div",
        //     {
        //         classes: ["popup-menu", "options"],
        //         parentToAppend: popUpBtn,
        //         // childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
        //         style: {
        //             ...cssLabel
        //         }

        //     }
        // )

        // this.btnBalance = CreateElement("div", {
        //     classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
        //         position: "relative",
        //         //left: "80px",
        //         width: Scale.Wpx(220),
        //         ...cssButton
        //     }
        // });
        // let btnBalanceLabel = CreateElement("div", {
        //     classes: ["but-credit-label", "label"],
        //     parentToAppend: this.btnBalance,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.balance),
        //     style: {
        //         ...cssLabel
        //     }
        // });

        // this.balanceCurrency = CreateElement("div", {
        //     classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
        //         ...cssCurrency
        //     }
        // });
        // let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
        // this.balanceCredits = CreateElement("div", {
        //     classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
        //         ...cssCredit
        //     }
        // });
        // let btnBalanceLinear = CreateElement("div", {
        //     classes: ["linear"], parentToAppend: this.btnBalance, style: {
        //         ...cssLinear
        //     }
        // });

        // let btnTotalbet = CreateElement("div", {
        //     classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
        //         //alignSelf: "flex-end",
        //         //flexGrow: "1",
        //         position: "relative",
        //         //left: "127px",
        //         width: Scale.Wpx(122),
        //         ...cssButton
        //     }
        // });
        // this.butTotalBet = btnTotalbet;
        // let btnTotalbetLabel = CreateElement("div", {
        //     classes: ["but-totalbet-label", "label"],
        //     parentToAppend: btnTotalbet,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
        //     style: {
        //         ...cssLabel
        //     }
        // });
        // this.totalBetCurrency = CreateElement("div", {
        //     classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
        //         ...cssCurrency
        //     }
        // });
        // // TODO span
        // this.totalBetCredits = CreateElement("div", {
        //     classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
        //         ...cssCredit
        //     }
        // });
        // let btnTotalbetLinear = CreateElement("div", {
        //     classes: ["linear"], parentToAppend: btnTotalbet, style: {
        //         ...cssLinear
        //     }
        // });

        // let btnPerLine = CreateElement("div", {
        //     classes: ["but-betperline", "button"],
        //     parentToAppend: grpDenomBalance,
        //     style: {
        //         alignSelf: "flex-end",
        //         flexGrow: "1",
        //         ...cssButton,
        //         display: "none",
        //     }
        // });
        // let btnPerLineLabel = CreateElement("div", {
        //     classes: ["but-betperline-label", "label"],
        //     parentToAppend: btnPerLine,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.tline),
        //     style: {
        //         ...cssLabel
        //     }
        // });
        // this.betCredits = CreateElement("div", {
        //     classes: ["but-betperline-credit", "credit"],
        //     parentToAppend: btnPerLine,
        //     innerHTML: "123",
        //     style: {
        //         ...cssCredit
        //     }
        // });
        // this.betCurrency = CreateElement("div", {
        //     classes: ["but-betperline-currency", "currency"],
        //     parentToAppend: btnPerLine,
        //     style: {
        //         ...cssCurrency
        //     }
        // });

        // let centerCol = CreateElement("div", {
        //     classes: ["but-vertical-group"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup,
        //         width:"33%"
        //     }
        // });

        // let butWin = CreateElement("div", {
        //     classes: ["but-win", "button"],
        //     parentToAppend: centerCol,
        //     style: {
        //         position: "relative",
        //         ...cssButton,
        //         flexGrow: "1",
        //     }
        // });

        // let butWinLabel = CreateElement("div", {
        //     classes: ["but-win-label", "label"],
        //     parentToAppend: butWin,
        //     style: {
        //         fontSize: Scale.fhpx(30),
        //         lineHeight: "0px",
        //         ...cssLabel
        //     }
        // });

        // this.winCurrency = CreateElement("div", {
        //     classes: ["but-win-currency", "currency"],
        //     parentToAppend: butWin,
        //     style: {
        //         fontSize: Scale.fhpx(40),
        //         textAlign: "center",
        //         color: "yellow",
        //         textShadow: "0 0 10px black",
        //         position: "relative",
        //         top: Scale.Ypx(30),
        //         //...cssCurrency
        //     }
        // });

        // this.winCredits = CreateElement("div", {
        //     classes: ["but-win-credit", "credit"],
        //     parentToAppend: butWin,
        //     style: {
        //         ...cssCredit,
        //         fontSize: Scale.fhpx(60),
        //         lineHeight: Scale.Hpx(100),
        //         marginTop: Scale.Ypx(2),
        //     }
        // });

        // let butWinLinear = CreateElement("div", {
        //     classes: ["linear"],
        //     parentToAppend: butWin,
        //     style: {
        //         ...cssLinear,


        //     }
        // });

        // let grpRight = CreateElement("div", {
        //     classes: ["but-vertical-group", "but-right-group"],
        //     parentToAppend: this.view,
        //     style: {
        //         ...cssVerticalGroup,
        //         width: "34%",
        //     }
        // });

        // this.messageElem = CreateElement("div", {
        //     classes: ["but-message", "button", "message-value", "message"],
        //     parentToAppend: grpRight,
        //     style: {
        //         //height: Scale.Hpx(35),
        //         //position: "relative",
        //         //left: "-30px",
        //         //...cssButton,
        //         display: "flex",
        //         justifyContent: "center",
        //         width: "100%",
        //         // alignItems: "center",
        //         //top: "8px",
        //         //right: Scale.Hpx(70),
                
        //         fontSize: Scale.fhpx(20),
        //         color: "white",
        //         textShadow: `0 0 ${Scale.XYpx(10)} black`,
        //         background: "transparent",

        //     }
        // });


        // let grpRightHorizontal = CreateElement("div", {
        //     classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
        //     parentToAppend: grpRight,
        //     style: {
        //         ...cssHorizontalGroup,
        //         //flexGrow: "1"
        //         justifyContent: "space-evenly",
        //         alignItems: "flex-end",
        //         height: "100%",
        //     }
        // });

        // // grpRightHorizontal.addEventListener("mouseenter", () => this.HidePopUp());

        // // let grpAutoplayMaxbet = CreateElement("div", {
        // //     classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
        // //     parentToAppend: grpRight,
        // //     style: {
        // //         ...cssHorizontalGroup,
        // //         //flexGrow: "1"
        // //         justifyContent: "space-evenly",
        // //         alignItems: "flex-end",
        // //         height: "100%",

        // //     }
        // // });

        // this.butAutoplay = CreateElement("div", {
        //     classes: ["but-auto-play", "button"],
        //     parentToAppend: grpRightHorizontal,
        //     style: {
        //         //flexGrow: "1",
        //         // alignSelf: "flex-end",
        //         ...cssButton,
        //         width: Scale.Wpx(120),
        //         //display: "none",
        //     }
        // });

        // let butAutplayLabel = CreateElement("div", {
        //     classes: ["but-auto-play-label", "label"],
        //     parentToAppend: this.butAutoplay,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.auto),
        //     style: {
        //         ...cssLabel,
        //         margin: Scale.XYpx(7),
        //         lineHeight: Scale.fhpx(20),
        //         display: "block",
        //     }
        // });

        // this.butMaxBet = CreateElement("div", {
        //     classes: ["but-max-bet", "button"],
        //     parentToAppend: grpRightHorizontal,
        //     style: {
        //         //flexGrow: "1",

        //         // alignSelf: "flex-end",

        //         ...cssButton,


        //         width: Scale.Wpx(120),
        //     }
        // })

        // let butMaxBetLabel = CreateElement("div", {
        //     classes: ["but-max-bet-label", "label"],
        //     parentToAppend: this.butMaxBet,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
        //     style: {
        //         ...cssLabel,
        //         marginTop: Scale.Ypx(21),
        //         lineHeight: Scale.Hpx(20),
        //         display:"block"
        //     }
        // });

        // let butMaxBetLinear = CreateElement("div", {
        //     classes: ["linear"],
        //     parentToAppend: this.butMaxBet,
        //     style: {
        //         ...cssLinear,
        //         marginTop: Scale.Ypx(20),
        //     }
        // });

        // this.butSpin = CreateElement("div", {
        //     classes: ["but-spin", "button"],
        //     parentToAppend: grpRightHorizontal,
        //     style: {
        //         width: Scale.Wpx(300),
        //         alignSelf: "flex-end",
        //         ...cssButton,
        //         position: "relative"
        //     }
        // });

        // if (this.params.doubleupEnabled) {
        //     this.butDoubleUp = CreateElement("div", {
        //         classes: ["but-gamble", "button"],
        //         parentToAppend: grpRightHorizontal,
        //         style: {
        //             width: Scale.Wpx(100),
        //             alignSelf: "flex-end",
        //             ...cssButton,
        //             position: "relative"
        //         }
        //     });
        // }

        // // <div class="but-turbo-label">Hold for turbo</div>
        // this.turboElem = CreateElement("div", {
        //     classes: ["but-turbo-label"],
        //     parentToAppend: this.butSpin,
        //     innerHTML: "Hold for turbo",
        //     style: {
        //         //position: "absolute",
        //         top: Scale.Ypx(10),
        //         width: "100%",
        //         fontSize: Scale.fhpx(12),
        //         color: "white",
        //         textAlign: "center",
        //         textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
        //     }
        // });

        // this.spinElem = CreateElement("div", {
        //     classes: ["but-spin-label", "label"],
        //     parentToAppend: this.butSpin,
        //     style: {
        //         ...cssLabel,
        //         fontSize: Scale.fhpx(40),
        //         lineHeight: Scale.Hpx(85)

        //     }
        // });

        // if (this.params.doubleupEnabled) {
        //     let doubleuplabel = CreateElement("div", {
        //         classes: ["but-gamble-label", "label"],
        //         parentToAppend: this.butDoubleUp,
        //         childToAppend: this.translator.Anchor(() => this.translator.t.doubleup),
        //         style: {
        //             ...cssLabel,
        //             marginTop: Scale.Ypx(10),
        //             lineHeight: Scale.Hpx(20)

        //         }
        //     });
        // }


        // let btnSpinLinear = CreateElement("div", {
        //     classes: ["linear"], parentToAppend: this.butSpin, style: {
        //         ...cssLinear
        //     }
        // });

        // // let rightCol = CreateElement("div", {
        // //     classes: ["but-vertical-group", "but-group-help-games"],
        // //     parentToAppend: this.view,
        // //     style: {
        // //         ...cssVerticalGroup
        // //     }
        // // });

        // this.butMenu = CreateElement("div", {
        //     classes: ["but-games", "button"],
        //     parentToAppend: grpRightHorizontal,
        //     style: {
        //         ...cssButton,
        //         // ...cssLeftRightButton,
        //         width: Scale.Wpx(110),
        //     }
        // });
        // let butMenuLabel = CreateElement("div", {
        //     classes: ["but-games-icon", "label"],
        //     parentToAppend: this.butMenu,
        //     childToAppend: this.translator.Anchor(() => this.translator.t.menu),
        //     style: {
        //         ...cssLabel,
        //         lineHeight: Scale.fhpx(23),


        //     }
        // });

        // if (this.backendSettings?.GetBool("accounting.payoutButton")) {
        //     // this.ConstructButton(Button.ButtonPayout, this.butcash);
        //     this.butcash.style.visibility = "visible";
        // }
        // else {
        //     this.butcash.style.visibility = "hidden"
        // }

        // this.ConstructButton(Button.ButtonSettings, popUpBtn);
        this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);
        this.ConstructButton(Button.ButtonCallAttendant,this.attendantElem);
        this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
        this.GetDefaultReelSpeed();
        // this.UpdateIconVolume(this.audio.GetAudioLevel());
        // this.GetDefaultVolumeLevel();
    }
    protected defaultSpeedType: SpeedType;

    protected GetDefaultReelSpeed()
    {
        this.defaultSpeedType = this.speedManager.GetDefaultReelSpeedType();
        let speedLevel = this.speedManager.GetDefaultSpeedLevel();

        this.UpdateSpeedIcon(speedLevel);
    }

    public DefaultVolumeLevel(level: number)
    {
        let defaultVolume = level;
        this.UpdateIconVolume(defaultVolume);
        this.audio.SetVolume(defaultVolume);
    }


    protected isVisible: boolean = false;
    protected popUpAnimation: TweenLite = null;
    protected allowToShow: boolean = true;



    public ShowPopUp()
    {
        if (!this.allowToShow)
        {
            return 
        }
        
        if (!this.isVisible)
        {

            this.UpdateIconVolume(this.audio.GetVolumeLevel())
            this.isVisible = true;
            this.view.style.display = "flex";
            this.popUpMenu.style.display = "flex";

             this.popUpAnimation = gsap.fromTo(this.popUpMenu,  
                { scale: 0.15, transformOrigin : "center",  duration: 0.5, yoyo: true, ease: "none", },
                { scale: 1}
            );
            

            return;
        }

        this.isVisible = false;
        this.allowToShow = false;
        this.popUpAnimation = gsap.fromTo(this.popUpMenu,  
            { scale: 1},
            { scale: 0.15, transformOrigin : "center", duration: 0.5, yoyo: true, ease: "none", onComplete: () => this.HidePopUp()}
        );
        
        // popUpAnimation?.kill()


    }
    public  HidePopUp()
    {
        // if (this.popUpMenu)
        // {
            this.view.style.display ="none";
            this.popUpAnimation?.kill()
            this.allowToShow = true;    
            this.isVisible = false;

            this.hidePopUpCallback?.();
        // }



    }

    public UpdateIconVolume(volumeLevel:number):void{

		// Validar que volumeLevel no sea undefined o NaN
		if (volumeLevel === undefined || volumeLevel === null || Number.isNaN(volumeLevel)) {
			volumeLevel = 0; // Valor por defecto
		}

		// Asegurar que el valor esté en el rango válido (0 a MaxVolumeLevel)
		const maxVolume = AudioManager.MaxVolumeLevel;
		if (volumeLevel < 0) {
			volumeLevel = 0;
		} else if (volumeLevel > maxVolume) {
			volumeLevel = maxVolume;
		}

		// Asegurar que el icono existe en el mapa, usar 0 como fallback
		const volumeIcon = VolumeIconsMap[volumeLevel] || VolumeIconsMap[0];

		// switch(volumeLevel)
		// {
		// case 0:
        this.butVolume.style.backgroundImage = `url('data:image/svg+xml;utf8,${volumeIcon}')`;
        this.butVolume.style.backgroundSize = "cover";
        this.butVolume.style.backgroundRepeat = "no-repeat";
		// break;
		// case 1:
        // this.butVolume.style.backgroundImage = `url('data:image/svg+xml;utf8,${PopUpPanelIcons.Volume1}')`;
        // this.butVolume.style.backgroundSize = "cover";
        // this.butVolume.style.backgroundRepeat = "no-repeat";
		// break;
		// case 2:
        // this.butVolume.style.backgroundImage = `url('data:image/svg+xml;utf8,${PopUpPanelIcons.Volume2}')`;
        // this.butVolume.style.backgroundSize = "cover";
        // this.butVolume.style.backgroundRepeat = "no-repeat";
		// break;
		// case 3:
        // this.butVolume.style.backgroundImage = `url('data:image/svg+xml;utf8,${PopUpPanelIcons.Volume3}')`;
        // this.butVolume.style.backgroundSize = "cover";
        // this.butVolume.style.backgroundRepeat = "no-repeat";
		// break;
		// }
        this.volumeRange.value = volumeLevel.toString();

	}


    protected speedType: SpeedType;
    protected celebType: CelebrationType;

    protected SetGameSpeed(speedLevel: number)
    {
        this.speedManager.SetSelectedSpeedLevel(speedLevel);
        this.speedManager.SetSpeed();
    }

    
    public UpdateSpeedIcon(level: number)
    {
        this.SpeedRange.value = level.toString();
        this.butSpeed.style.backgroundImage = `url('data:image/svg+xml;utf8,${SpeedIconMap[speedTypeMap[level]]}')`;
        this.butSpeed.style.backgroundSize = "cover";
        this.butSpeed.style.backgroundRepeat = "no-repeat";
    }

    public  CheckPopUpVisibility(): boolean
    {
        return this.isVisible;
    }

    public View(): HTMLElement
    {
       return this.view
    }
    public SetDenom(denom:string): void {
		this.denomElem.innerText = `DENOM \n ${denom}`;
	}

    public hidePopUpCallback: hidePopUpSettingsCallback = null;

    public ConstructButton(button: Button, element: HTMLElement, autoRelease: number = 0): void
	{
        if (!element)
        {
            debugger;
            throw "Element can't be empty";
        }

        if (this.buttonState.get(button))
        {
            debugger;
            throw `Button ${button} already constructed`;
        }

        {
            let buttonState: ButtonState = {
                button: button,
                element: element,
                isPressed: false,
                delayReleaseTime: this.systemContext.TimingContext().CreateTimeout(`Button-${button}-delayrelease`, 100, () => {
                    
                    if (buttonState.releasePending)
                    {
                        this.AnimateButtonPress(buttonState, false);
                    }

                    buttonState.releasePending = false;
                }),

                releasePending: false,
                autoReleaseTimer: autoRelease > 0 ? this.systemContext.TimingContext().CreateTimeout(`Button-${button}-autorelease`, autoRelease, () => {
                    this.AnimateButtonPress(buttonState, false);
                    buttonState.releasePending = false;
                }) : null
            };

            this.buttonState.set(button, buttonState);
        }

		this.butElem.set(button, element);

        AddMouseDownUpListener(
            element, 
            () => service.iomanager.UpdateButton(button, true),
            () => service.iomanager.UpdateButton(button, false)
        );
	}

    public OnSpeedChanged: SpeedChangedCallback;


    protected AnimateButtonPress(buttonState: ButtonState, pressed: boolean): void 
    {
        // press
        if (pressed)
        {
            SetStyles(buttonState.element, {
                // transform: `translateY(${Scale.Ypx(-8)})`,
                boxShadow: `${Scale.Xpx(0)} ${Scale.Ypx(5)} ${Scale.XYpx(16)} rgb(0,255 , 0)`,
            });
        }
        // release
        else
        {
            SetStyles(buttonState.element, {
                // transform: "translateY(0px)",
                boxShadow: "none",
            })
        }
	}
}

export class PopUpSettingsResponsive extends PopUpSettings
{
    public override ConstructHtml() {

        this.view = CreateElement("div", {
         classes:["pop-up", "container"],
         style:
         {
             display: "none",
             flexDirection: "column",
             position: "absolute",
             bottom: Scale.Ypx(0),
             width: Scale.Wpx(1920),
             height: Scale.Hpx(1080),
             justifyContent: "center",
             alignItems: "center",
             zIndex: ZIndex.SettingsMenu.toString(),
             background: "rgba(0,0,0,0.8)",
         },
         
        })
        this.view.addEventListener('mousedown', () => {if (this.allowToHidePopUpItems) this.HidePopUp()});
 
         let cssLinear: Partial<CSSStyleDeclaration> = {
             borderWidth: Scale.XYpx(5),
             borderStyle: "solid",
             position: "relative",
             margin: "0px auto",
             bottom: Scale.Ypx(5),
             filter: `blur(${Scale.XYpx(2)})`,
             width: "80%",
             borderImage: this.btnColors.linearColor
 
         };
 
 
         let cssVerticalGroup: Partial<CSSStyleDeclaration> = {
             display: "flex",
             flexDirection: "column",
             //justifyContent: "flex-end",
         };
 
         let cssHorizontalGroup: Partial<CSSStyleDeclaration> = {
             display: "flex",
             flexDirection: "row",
             flexGrow: "1",
             alignItems: "end",
         };
 
         let cssLeftRightButton: Partial<CSSStyleDeclaration> = {
             flexGrow: "1",
             height: Scale.Hpx(47),
             width: Scale.Wpx(85),
         };
 
         let cssButton: Partial<CSSStyleDeclaration> = {
             borderRadius: Scale.XYpx(16),
 
             border: `${Scale.XYpx(7)} solid transparent`,
             //backgroundClip: "padding-box",
             borderStyle: "inset",
 
             margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
             height: Scale.Hpx(100),
 
             display: "flex",
             flexDirection: "column",
             justifyContent: "space-evenly",
 
             backgroundOrigin: "border-box",
             backgroundClip: "content-box, border-box",
             backgroundImage: this.btnColors.backgroundButtonColor
         };
 
         let cssLabel: Partial<CSSStyleDeclaration> = {
             fontSize: Scale.fhpx(20),
             lineHeight: "0px",
             //color: "white",
             textAlign: "center",
 
 
             fontFamily: "NotoSansDisplay-Bold",
             fontWeight: "bold",
 
             color: "white",
             textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
         };
 
         let SvgIcon: Partial<CSSStyleDeclaration> =
         {
             display: "flex",
             width: "100%",
             height: "100%",
             alignItems: "center",
             justifyContent: "center"
         }
 
         let horizontalMiniMenu: Partial<CSSStyleDeclaration> =
         {
             display: "flex",
             flexDirection: "row",
             //width:"100%",
             //height:"100%",
             alignItems: "center",
             justifyContent: "center"
         }
 
         let cssMessageValue: Partial<CSSStyleDeclaration> = {
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
             fontSize: Scale.fhpx(20),
 
             color: "white",
             textShadow: "0 0 10px black",
             background: "transparent",
             position: "relative",
             top: "0px",
 
         };
 
         let cssCredit: Partial<CSSStyleDeclaration> = {
             fontSize: Scale.fhpx(35),
             lineHeight: Scale.Hpx(40),
             textAlign: "center",
             height: "100%",
 
             display: "flex",
             justifyContent: "center",
             alignItems: "center",
 
             color: "white",
 
             textShadow: `0 0 ${Scale.XYpx(10)} black`,
             position: "relative",
             top: Scale.Ypx(6),
         };
 
         let cssCurrency: Partial<CSSStyleDeclaration> = {
             fontSize: Scale.fhpx(25),
             textAlign: "center",
             color: "yellow",
             textShadow: `0 0 ${Scale.XYpx(10)} black`,
             position: "relative",
             top: Scale.Ypx(12),
             left: Scale.Ypx(0),
             margin: Scale.Ypx(0),
         };
 
         this.popUpMenu = CreateElement("div", {
             classes: ["popup-menu", "items"],
             parentToAppend: this.view,
             // childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
             style: {
                 //position: "absolute",
                 //display: "none",
                 // bottom: Scale.Ypx(165),
                 backgroundImage: this.btnColors.backgroundButtonColor,
                 justifyContent: "center",
                 width: Scale.Wpx(900),
                 height: Scale.Hpx(1050),
                 borderRadius: Scale.XYpx(16),
 
                 border: `${Scale.XYpx(7)} solid transparent`,
                 //backgroundClip: "padding-box",
                 borderStyle: "inset",
     
                 margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
                 // height: Scale.Hpx(216),
     
                 backgroundOrigin: "border-box",
                 backgroundClip: "content-box, border-box",   
                 flexDirection: "column",
                 //left: Scale.Xpx(15),
                 //zIndex: ZIndex.SettingsMenu.toString()
             }
         })
         this.popUpMenu.addEventListener('mouseenter', () => this.allowToHidePopUpItems = false);
         this.popUpMenu.addEventListener('mouseleave', () => this.allowToHidePopUpItems = true);
 
         let settingTitle= CreateElement("div", {
             classes: ["game-config", "pop-up"],
             parentToAppend: this.popUpMenu,
             style: {
                 position: "relative",
                 fontSize: Scale.fhpx(64.5),
                 textAlign: "center",
                 fontWeight: "bold", 
                 
                 color: "white",
                 textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
                 lineHeight: Scale.Hpx(133),
             },
             childToAppend: service.translator.Anchor(() => service.translator.t.settingsTitle)
         });
 
         /* #region Left column */
         let leftCol = CreateElement("div", {
             classes: ["but-vertical-group", "but-group-value-collect"],
             parentToAppend: this.popUpMenu,
             style: {
                 ...cssVerticalGroup,
                 alignItems: "center",
                // margin:`${Scale.Wpx(15)} ${Scale.Wpx(15)}`,
                 justifyContent:"space-around"
             }
         });
 
         let volumeMenu = CreateElement("div", {
             classes: ["volume-submenu"],
             parentToAppend: leftCol,
             style: {
                 ...horizontalMiniMenu,
                 justifyContent: "flex-end"
 
                // rowGap: Scale.Wpx(15),
             }
         })
 
         this.butVolume = CreateElement("div", {
             classes: ["but-vol", "button"],
             parentToAppend: volumeMenu,
             style: {
                 // ...cssButton,
                 // ...cssLeftRightButton,
                 width: Scale.Wpx(200),
                 height: Scale.Hpx(200),
             }
         });
 
         // this.butVolIcon = CreateElement("div", {
         //     classes: ["but-vol-icon", "icon"],
         //     //innerHTML: PopUpPanelIcons.Volume3,
         //     parentToAppend: this.butVolume,
         //     style: {
         //         // ...cssLabel
         //         ...SvgIcon,
         //     }
         // });
 
         this.volumeRange = CreateElement("input", {
             parentToAppend:volumeMenu,   
             style: {
                 appearance: "none",
                 width: Scale.Wpx(600),
                 height: Scale.Hpx(50),
                 border: "solid darkgoldenrod",
                 backgroundColor: "transparent",
                 zIndex: "2"
             }         
         });
 
         this.volumeRange.type = "range";
         this.volumeRange.min = "0";
         this.volumeRange.max = AudioManager.MaxVolumeLevel.toString();
 
 
         this.volumeRange.addEventListener("input", ()=>{
             this.audio.SetVolume(this.volumeRange.valueAsNumber);
             this.UpdateIconVolume(this.audio.GetVolumeLevel());
         });
 
         this.volumeSelectorStyle = CreateElement("style",
         {
             innerHTML:  this.SELECTOR,
             parentToAppend: this.volumeRange
 
         })
 
         let volumeBackground = CreateElement("div", {
             classes:["volume-scale", "indicator"],
             parentToAppend: volumeMenu,
             style:{
                 width: Scale.Wpx(600),
                 height: Scale.Hpx(50),
                 position: "absolute",
                 //zIndex: "-1",
                 display: "flex",
                 flexDirection: "column"
                 // backgroundColor: "transparente"
             }
         })
 
         let transparentRectangle = CreateElement("div", {
             parentToPrepend: volumeBackground,
             style:
             {
                 width:"100%",
                 height: "100%",
                 clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                 position: "absolute",
                 top: "0",
                 left: "0",
                 // backgroundColor: "orange"
             }
         })
 
         let gradientRectangle = CreateElement("div", {
             parentToAppend: volumeBackground,
             style:
             {
                 width:"100%",
                 height: "100%",
                 clipPath: "polygon(0% 0%, 100% 0%, 0% 100%)",
                 position: "absolute",
                 top: "0",
                 right: "0",
                 backgroundImage: "linear-gradient(-90deg, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                 transform: "rotate(180deg)"
 
             }
         })
 
         let volumeTitle = CreateElement("div", {
             classes:["volume","title"],
             parentToAppend: leftCol,
             childToAppend: this.translator.Anchor(() => this.translator.t.volumeControlHeader),
             style: {
                 ...cssLabel,
                 display:"flex",
                 // position: "absolute",
                 width: "100%",
                 height: Scale.Hpx(90),
                 // alignItems: "center",
                 justifyContent: "center",
             }
         });
         
 
 
 
 
         let speedMenu = CreateElement("div", {
             classes: ["speed-submenu"],
             parentToAppend: leftCol,
             style:{
                 ...horizontalMiniMenu,
                 // rowGap: Scale.Wpx(15),
             }
         })
         this.butSpeed = CreateElement("div", {
             classes: ["but-speed", "button"],
             parentToAppend: speedMenu,
             style: {
                 // ...cssButton,
                 // ...cssLeftRightButton,
                 width: Scale.Wpx(200),
                 height: Scale.Hpx(200),
             }
         });
 
         // this.SpeedIcon = CreateElement("div", {
         //     classes: ["but-speed-icon", "icon"],
         //     innerHTML: PopUpPanelIcons.Speed0,
         //     parentToAppend: butSpeed,
         //     style: {
         //         // ...cssLabel
         //         ...SvgIcon
         //     }
         // });
         
         this.SpeedRange = CreateElement("input", {
             parentToAppend:speedMenu,      
             style:
             {
                 appearance: "none",
                 width: Scale.Wpx(600),
                 height: Scale.Hpx(50),
                 backgroundImage: "linear-gradient(to right, #1e8a00 0%, #ffdd00 50%, #a40e0e 100%)",
                 border: "solid darkgoldenrod",
             }      
         });
 
         this.SpeedRange.type = "range";
         this.SpeedRange.min = "1";
         this.SpeedRange.max = "3";
 
         this.SpeedRange.addEventListener("input", () =>
         {
             this.SetGameSpeed(this.SpeedRange.valueAsNumber)
         });
 
         this.SpeedSelectortStyle = CreateElement("style",
         {
             innerHTML:  this.SELECTOR,
             parentToAppend: this.SpeedRange
 
         })
          let speedTitle = CreateElement("div", {
             classes: ["speed","title"],
             parentToAppend: leftCol,
             childToAppend: this.translator.Anchor(() => this.translator.t.speedControlHeader),
 
             style:{
                 ...cssLabel,
                 // position: "absolute",
                 width: "100%",
                 height: Scale.Hpx(90),
                 display: "flex",
                 // alignItems: "end",
                 justifyContent: "center",
 
             }
          })
 
 
         let miniMenu = CreateElement("div", {
             parentToAppend: leftCol,
             style: {
                 ...horizontalMiniMenu,
                 // rowGap: Scale.Wpx(15)
 
             }
         })
 
         this.butDenom = CreateElement("div", {
             classes: ["but-denom", "button"],
             parentToAppend: miniMenu,
             style: {
                 ...cssButton,
                 width: Scale.Wpx(120*2),
                 height: Scale.Hpx(100*2),
             }
         });
 
         this.denomElem = CreateElement("div", {
             classes: ["denom-value", "message-value"],
             parentToAppend: this.butDenom,
             style: {
                 ...cssLabel,
                 lineHeight: "initial",
                 fontSize: Scale.fhpx(37.5),
             }
         });
 
         // let butDenomDenom = CreateElement("div", {
         //     classes: ["denom-denom"],
         //     parentToAppend: this.denomElem
         // });
 
         /* #region Left column */
         // let leftCol2 = CreateElement("div", {
         //     classes: ["but-vertical-group", "but-group-payout-attendant"],
         //     parentToAppend: this.popUpMenu,
         //     style: {
         //         ...cssVerticalGroup
         //     }
         // });
 
         this.butHelp = CreateElement("div", {
             classes: ["but-help", "button"],
             parentToAppend: miniMenu,
             style: {
                 ...cssButton,
                 width: Scale.Wpx(120*2),
                 height: Scale.Hpx(100*2),
 
             }
         });
 
         let butHelpBack = CreateElement("div", {
             classes: ["help-background"],
             parentToAppend: this.butHelp
         });
 
         let butHelpLabel = CreateElement("div", {
             classes: ["but-help-icon", "label"],
             parentToAppend: butHelpBack,
             innerHTML: "INFO",
             style: {
                 ...cssLabel,
                 fontSize: Scale.Wpx(75)
             }
         });
 
        //  this.attendantElem = CreateElement("div", {
        //      classes: ["but-attendant", "button"],
        //      parentToAppend: miniMenu,
        //      style: {
        //          ...cssButton,
        //          width: Scale.Wpx(120*2),
        //          height: Scale.Hpx(100*2),
        //      }
        //  });
 
 
        //  let btnAttendantLabel = CreateElement("div", {
        //      classes: ["but-attendant-label", "label"],
        //      parentToAppend: this.attendantElem,
        //      childToAppend: this.translator.Anchor(() => this.translator.t.callAttendant),
        //      style: {
        //          ...cssLabel,
        //          lineHeight: "initial",//Scale.fhpx(30),
        //          fontSize: Scale.fhpx(37.5),
        //      }
        //  });
 
         let ExitBtn = CreateElement("div", {
             classes:["but-exit-popup"],
             parentToAppend: leftCol,
             style: {
                 ...cssButton,
                 width: Scale.Wpx(500),
                 height: Scale.Hpx(100),
                 backgroundColor: "red",
                 backgroundImage: "linear-gradient(#FF0101)",
             },
             mousedown: () => {
                 this.HidePopUp();
             },
         });
 
         let ExitBtnLabel = CreateElement("div",
             {
                 classes:["eixt","label"],
                 parentToAppend: ExitBtn,
                 childToAppend: this.translator.Anchor(() => this.translator.t.backtogametxt),
                 style: {
                     ...cssLabel,
                     fontSize: Scale.fhpx(30),
                     // color: "red",
                 }
             }
         )
 
 
         // // LEFT GROUP
         // let grpLeft = CreateElement("div", {
         //     classes: ["but-vertical-group", "but-left-group"], parentToAppend: this.view, style: {
         //         ...cssVerticalGroup,
         //         width: "33%",
 
         //     }
         // });
 
         // let btnLines = CreateElement("div", {
         //     classes: ["but-lines", "button"], parentToAppend: grpLeft, style: {
         //         //height: Scale.Hpx(35),
         //         //position: "relative",
         //         //left: "-224px",
         //         //background: "transparent",
         //         //...cssButton
         //         display: "flex",
         //         //alignItems: "center",
         //         justifyContent: "center",
         //         width: "100%"
         //     }
         // });
 
         // this.linesMessage = this.translator.Translate(() => this.translator.t.playingOnLines(this.lines));
         // let btnLinesValue = CreateElement("div", {
         //     classes: ["but-lines-value", "message-value"],
         //     parentToAppend: btnLines,
         //     childToAppend: this.linesMessage.location,
         //     style: {
         //         //...cssMessageValue
         //         //display: "flex",
         //         // justifyContent: "center",
         //         // alignItems: "center",
         //         fontSize: Scale.fhpx(20),
 
         //         color: "white",
         //         textShadow: "0 0 10px black",
         //         background: "transparent",
         //         //position: "absolute",
         //         // top: "8px",
         //         // left: Scale.Hpx(360),
         //     }
         // });
 
         // let grpDenomBalance = CreateElement("div", {
         //     classes: ["but-horizontal-group", "but-group-denom-balance"], parentToAppend: grpLeft, style: {
         //         ...cssHorizontalGroup,
         //         //flexGrow: "1"
         //         justifyContent: "space-evenly",
         //         alignItems: "flex-end",
         //         height: "100%",
         //     }
         // });
 
         // // grpDenomBalance.addEventListener("mouseenter", () => this.HidePopUp());
 
         // this.butcash = CreateElement("div", {
         //     classes: ["but-cash", "button"],
         //     parentToAppend: grpDenomBalance,
         //     style: {
         //         ...cssButton,
         //         width: Scale.Wpx(120)//Scale.Wpx(100),
         //         // height: Scale.Hpx(70),
         //         //position: "absolute",
         //     }
         // });
 
         // let btnCashLabel = CreateElement("div", {
         //     classes: ["but-cash-label", "label"],
         //     parentToAppend: this.butcash,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.collect),
         //     style: {
         //         ...cssLabel
         //     }
         // });
 
         // let popUpBtn = CreateElement("div", {
         //     classes: ["pop-up","trigger"],
         //     parentToAppend: grpDenomBalance,
         //     style:{
         //         ...cssButton,
         //         width: Scale.Wpx(120),
         //     }
 
         //     // mousedown: () => {
         //     //     this.ShowPopUp();
         //     // }
         // })
 
         // let settingsIconDiv = CreateElement("div", {
         //     parentToAppend: popUpBtn,
         //     innerHTML: PopUpPanelIcons.Settings,
         //     style: {
         //         ...SvgIcon
 
         //     }
         // })
 
         // let popUpMenuBtnlabel = CreateElement("div",
         //     {
         //         classes: ["popup-menu", "options"],
         //         parentToAppend: popUpBtn,
         //         // childToAppend: this.translator.Anchor(() => this.translator.t.optionsbtntxt),
         //         style: {
         //             ...cssLabel
         //         }
 
         //     }
         // )
 
         // this.btnBalance = CreateElement("div", {
         //     classes: ["but-credit", "button"], parentToAppend: grpDenomBalance, style: {
         //         position: "relative",
         //         //left: "80px",
         //         width: Scale.Wpx(220),
         //         ...cssButton
         //     }
         // });
         // let btnBalanceLabel = CreateElement("div", {
         //     classes: ["but-credit-label", "label"],
         //     parentToAppend: this.btnBalance,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.balance),
         //     style: {
         //         ...cssLabel
         //     }
         // });
 
         // this.balanceCurrency = CreateElement("div", {
         //     classes: ["but-credit-currency", "currency"], parentToAppend: this.btnBalance, style: {
         //         ...cssCurrency
         //     }
         // });
         // let btnBalanceCurrencyValue = CreateElement("span", { classes: ["but-credit-currency-value"], parentToAppend: this.balanceCurrency, innerHTML: "123,456.00" });
         // this.balanceCredits = CreateElement("div", {
         //     classes: ["but-credit-credit", "credit"], parentToAppend: this.btnBalance, innerHTML: "123456", style: {
         //         ...cssCredit
         //     }
         // });
         // let btnBalanceLinear = CreateElement("div", {
         //     classes: ["linear"], parentToAppend: this.btnBalance, style: {
         //         ...cssLinear
         //     }
         // });
 
         // let btnTotalbet = CreateElement("div", {
         //     classes: ["but-totalbet", "button"], parentToAppend: grpDenomBalance, style: {
         //         //alignSelf: "flex-end",
         //         //flexGrow: "1",
         //         position: "relative",
         //         //left: "127px",
         //         width: Scale.Wpx(122),
         //         ...cssButton
         //     }
         // });
         // this.butTotalBet = btnTotalbet;
         // let btnTotalbetLabel = CreateElement("div", {
         //     classes: ["but-totalbet-label", "label"],
         //     parentToAppend: btnTotalbet,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.tbet),
         //     style: {
         //         ...cssLabel
         //     }
         // });
         // this.totalBetCurrency = CreateElement("div", {
         //     classes: ["but-totalbet-currency", "currency"], parentToAppend: btnTotalbet, innerHTML: "123.00", style: {
         //         ...cssCurrency
         //     }
         // });
         // // TODO span
         // this.totalBetCredits = CreateElement("div", {
         //     classes: ["but-totalbet-credit", "credit"], parentToAppend: btnTotalbet, innerHTML: "123", style: {
         //         ...cssCredit
         //     }
         // });
         // let btnTotalbetLinear = CreateElement("div", {
         //     classes: ["linear"], parentToAppend: btnTotalbet, style: {
         //         ...cssLinear
         //     }
         // });
 
         // let btnPerLine = CreateElement("div", {
         //     classes: ["but-betperline", "button"],
         //     parentToAppend: grpDenomBalance,
         //     style: {
         //         alignSelf: "flex-end",
         //         flexGrow: "1",
         //         ...cssButton,
         //         display: "none",
         //     }
         // });
         // let btnPerLineLabel = CreateElement("div", {
         //     classes: ["but-betperline-label", "label"],
         //     parentToAppend: btnPerLine,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.tline),
         //     style: {
         //         ...cssLabel
         //     }
         // });
         // this.betCredits = CreateElement("div", {
         //     classes: ["but-betperline-credit", "credit"],
         //     parentToAppend: btnPerLine,
         //     innerHTML: "123",
         //     style: {
         //         ...cssCredit
         //     }
         // });
         // this.betCurrency = CreateElement("div", {
         //     classes: ["but-betperline-currency", "currency"],
         //     parentToAppend: btnPerLine,
         //     style: {
         //         ...cssCurrency
         //     }
         // });
 
         // let centerCol = CreateElement("div", {
         //     classes: ["but-vertical-group"],
         //     parentToAppend: this.view,
         //     style: {
         //         ...cssVerticalGroup,
         //         width:"33%"
         //     }
         // });
 
         // let butWin = CreateElement("div", {
         //     classes: ["but-win", "button"],
         //     parentToAppend: centerCol,
         //     style: {
         //         position: "relative",
         //         ...cssButton,
         //         flexGrow: "1",
         //     }
         // });
 
         // let butWinLabel = CreateElement("div", {
         //     classes: ["but-win-label", "label"],
         //     parentToAppend: butWin,
         //     style: {
         //         fontSize: Scale.fhpx(30),
         //         lineHeight: "0px",
         //         ...cssLabel
         //     }
         // });
 
         // this.winCurrency = CreateElement("div", {
         //     classes: ["but-win-currency", "currency"],
         //     parentToAppend: butWin,
         //     style: {
         //         fontSize: Scale.fhpx(40),
         //         textAlign: "center",
         //         color: "yellow",
         //         textShadow: "0 0 10px black",
         //         position: "relative",
         //         top: Scale.Ypx(30),
         //         //...cssCurrency
         //     }
         // });
 
         // this.winCredits = CreateElement("div", {
         //     classes: ["but-win-credit", "credit"],
         //     parentToAppend: butWin,
         //     style: {
         //         ...cssCredit,
         //         fontSize: Scale.fhpx(60),
         //         lineHeight: Scale.Hpx(100),
         //         marginTop: Scale.Ypx(2),
         //     }
         // });
 
         // let butWinLinear = CreateElement("div", {
         //     classes: ["linear"],
         //     parentToAppend: butWin,
         //     style: {
         //         ...cssLinear,
 
 
         //     }
         // });
 
         // let grpRight = CreateElement("div", {
         //     classes: ["but-vertical-group", "but-right-group"],
         //     parentToAppend: this.view,
         //     style: {
         //         ...cssVerticalGroup,
         //         width: "34%",
         //     }
         // });
 
         // this.messageElem = CreateElement("div", {
         //     classes: ["but-message", "button", "message-value", "message"],
         //     parentToAppend: grpRight,
         //     style: {
         //         //height: Scale.Hpx(35),
         //         //position: "relative",
         //         //left: "-30px",
         //         //...cssButton,
         //         display: "flex",
         //         justifyContent: "center",
         //         width: "100%",
         //         // alignItems: "center",
         //         //top: "8px",
         //         //right: Scale.Hpx(70),
                 
         //         fontSize: Scale.fhpx(20),
         //         color: "white",
         //         textShadow: `0 0 ${Scale.XYpx(10)} black`,
         //         background: "transparent",
 
         //     }
         // });
 
 
         // let grpRightHorizontal = CreateElement("div", {
         //     classes: ["but-horizontal-group", "but-group-autoplay-maxbet-spin"],
         //     parentToAppend: grpRight,
         //     style: {
         //         ...cssHorizontalGroup,
         //         //flexGrow: "1"
         //         justifyContent: "space-evenly",
         //         alignItems: "flex-end",
         //         height: "100%",
         //     }
         // });
 
         // // grpRightHorizontal.addEventListener("mouseenter", () => this.HidePopUp());
 
         // // let grpAutoplayMaxbet = CreateElement("div", {
         // //     classes: ["but-horizontal-group", "but-group-autoplay-maxbet"],
         // //     parentToAppend: grpRight,
         // //     style: {
         // //         ...cssHorizontalGroup,
         // //         //flexGrow: "1"
         // //         justifyContent: "space-evenly",
         // //         alignItems: "flex-end",
         // //         height: "100%",
 
         // //     }
         // // });
 
         // this.butAutoplay = CreateElement("div", {
         //     classes: ["but-auto-play", "button"],
         //     parentToAppend: grpRightHorizontal,
         //     style: {
         //         //flexGrow: "1",
         //         // alignSelf: "flex-end",
         //         ...cssButton,
         //         width: Scale.Wpx(120),
         //         //display: "none",
         //     }
         // });
 
         // let butAutplayLabel = CreateElement("div", {
         //     classes: ["but-auto-play-label", "label"],
         //     parentToAppend: this.butAutoplay,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.auto),
         //     style: {
         //         ...cssLabel,
         //         margin: Scale.XYpx(7),
         //         lineHeight: Scale.fhpx(20),
         //         display: "block",
         //     }
         // });
 
         // this.butMaxBet = CreateElement("div", {
         //     classes: ["but-max-bet", "button"],
         //     parentToAppend: grpRightHorizontal,
         //     style: {
         //         //flexGrow: "1",
 
         //         // alignSelf: "flex-end",
 
         //         ...cssButton,
 
 
         //         width: Scale.Wpx(120),
         //     }
         // })
 
         // let butMaxBetLabel = CreateElement("div", {
         //     classes: ["but-max-bet-label", "label"],
         //     parentToAppend: this.butMaxBet,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.maxbet),
         //     style: {
         //         ...cssLabel,
         //         marginTop: Scale.Ypx(21),
         //         lineHeight: Scale.Hpx(20),
         //         display:"block"
         //     }
         // });
 
         // let butMaxBetLinear = CreateElement("div", {
         //     classes: ["linear"],
         //     parentToAppend: this.butMaxBet,
         //     style: {
         //         ...cssLinear,
         //         marginTop: Scale.Ypx(20),
         //     }
         // });
 
         // this.butSpin = CreateElement("div", {
         //     classes: ["but-spin", "button"],
         //     parentToAppend: grpRightHorizontal,
         //     style: {
         //         width: Scale.Wpx(300),
         //         alignSelf: "flex-end",
         //         ...cssButton,
         //         position: "relative"
         //     }
         // });
 
         // if (this.params.doubleupEnabled) {
         //     this.butDoubleUp = CreateElement("div", {
         //         classes: ["but-gamble", "button"],
         //         parentToAppend: grpRightHorizontal,
         //         style: {
         //             width: Scale.Wpx(100),
         //             alignSelf: "flex-end",
         //             ...cssButton,
         //             position: "relative"
         //         }
         //     });
         // }
 
         // // <div class="but-turbo-label">Hold for turbo</div>
         // this.turboElem = CreateElement("div", {
         //     classes: ["but-turbo-label"],
         //     parentToAppend: this.butSpin,
         //     innerHTML: "Hold for turbo",
         //     style: {
         //         //position: "absolute",
         //         top: Scale.Ypx(10),
         //         width: "100%",
         //         fontSize: Scale.fhpx(12),
         //         color: "white",
         //         textAlign: "center",
         //         textShadow: "#001 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
         //     }
         // });
 
         // this.spinElem = CreateElement("div", {
         //     classes: ["but-spin-label", "label"],
         //     parentToAppend: this.butSpin,
         //     style: {
         //         ...cssLabel,
         //         fontSize: Scale.fhpx(40),
         //         lineHeight: Scale.Hpx(85)
 
         //     }
         // });
 
         // if (this.params.doubleupEnabled) {
         //     let doubleuplabel = CreateElement("div", {
         //         classes: ["but-gamble-label", "label"],
         //         parentToAppend: this.butDoubleUp,
         //         childToAppend: this.translator.Anchor(() => this.translator.t.doubleup),
         //         style: {
         //             ...cssLabel,
         //             marginTop: Scale.Ypx(10),
         //             lineHeight: Scale.Hpx(20)
 
         //         }
         //     });
         // }
 
 
         // let btnSpinLinear = CreateElement("div", {
         //     classes: ["linear"], parentToAppend: this.butSpin, style: {
         //         ...cssLinear
         //     }
         // });
 
         // // let rightCol = CreateElement("div", {
         // //     classes: ["but-vertical-group", "but-group-help-games"],
         // //     parentToAppend: this.view,
         // //     style: {
         // //         ...cssVerticalGroup
         // //     }
         // // });
 
         // this.butMenu = CreateElement("div", {
         //     classes: ["but-games", "button"],
         //     parentToAppend: grpRightHorizontal,
         //     style: {
         //         ...cssButton,
         //         // ...cssLeftRightButton,
         //         width: Scale.Wpx(110),
         //     }
         // });
         // let butMenuLabel = CreateElement("div", {
         //     classes: ["but-games-icon", "label"],
         //     parentToAppend: this.butMenu,
         //     childToAppend: this.translator.Anchor(() => this.translator.t.menu),
         //     style: {
         //         ...cssLabel,
         //         lineHeight: Scale.fhpx(23),
 
 
         //     }
         // });
 
         // if (this.backendSettings?.GetBool("accounting.payoutButton")) {
         //     // this.ConstructButton(Button.ButtonPayout, this.butcash);
         //     this.butcash.style.visibility = "visible";
         // }
         // else {
         //     this.butcash.style.visibility = "hidden"
         // }
 
         // this.ConstructButton(Button.ButtonSettings, popUpBtn);
         this.ConstructButton(Button.ButtonDenomMenu, this.butDenom, 500);
         // this.ConstructButton(Button.ButtonCallAttendant,this.attendantElem);
         this.ConstructButton(Button.ButtonHelp, this.butHelp, 500);
         this.GetDefaultReelSpeed();
         // this.UpdateIconVolume(this.audio.GetAudioLevel());
         // this.GetDefaultVolumeLevel();
     }

}
export type hidePopUpSettingsCallback = () => void; 

